/* Woofborhood – đợt 27 (04/11/2026)
   <wb-family>     hộp "Buy any 2 tees, save $10" + "Buying for family? Pick sizes" (snippets/wb-family.liquid)
   bảng chọn size  chọn màu + số áo từng size cho cả nhà, một lần thêm giỏ (Shopify.actions.updateCart), rồi mở ngăn kéo giỏ
   [data-wb-quick] nút + trên thẻ "Complete the set" mở bảng chọn size của áo đó (snippets/wb-complete-set.liquid)
   [data-wb-more]  link "Add another size" trong ngăn kéo giỏ (snippets/wb-cart-goal.liquid)
   <wb-zoom-hint>  nút kính lúp + chữ "Tap to zoom" trên ảnh sản phẩm (snippets/wb-zoom-hint.liquid)
   Buy 2, save $10 = giảm $10 một lần khi giỏ có từ 2 áo (giảm giá tự động của Shopify; ở đây chỉ để hiện cho khách). */
const MAXQ = 10;
const BUY2 = 1000;
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const money = (c) => '$' + (c / 100).toFixed(2);
const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
const svg = (d) => `<svg class="wb-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${d}</svg>`;
const I = {
  plus: svg('<path d="M12 5v14M5 12h14"/>'),
  minus: svg('<path d="M5 12h14"/>'),
  check: svg('<path d="M20 6 9 17l-5-5"/>'),
  x: svg('<path d="M18 6 6 18M6 6l12 12"/>'),
  mag: svg('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5M11 8v6M8 11h6"/>'),
};
const cartUrl = () => (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
/* đóng ngăn kéo giỏ nếu đang mở (Horizon giữ ngăn kéo mở khi sang trang khác) */
const closeDrawer = () => {
  const dr = document.querySelector('theme-drawer#cart-drawer');
  if (dr && dr.hasAttribute('open') && typeof dr.close === 'function') dr.close();
};
const esc = (s) => String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));

/* ---------- data + cart count ---------- */
const DATA = new Map();
function data(pid) {
  pid = String(pid);
  if (DATA.has(pid)) return DATA.get(pid);
  const el = document.querySelector(`script[data-wb-product="${pid}"]`);
  if (!el) return null;
  try {
    const d = JSON.parse(el.textContent);
    DATA.set(pid, d);
    return d;
  } catch (e) {
    console.warn('[wb-family] bad product data', e);
    return null;
  }
}
const cart = { n: null };
function cartN() {
  if (cart.n == null) {
    const f = document.querySelector('wb-family[data-n]');
    cart.n = f ? Number(f.dataset.n) || 0 : 0;
  }
  return cart.n;
}
async function refreshCart() {
  try {
    const r = await fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    cart.n = (await r.json()).item_count || 0;
  } catch (e) {
    return;
  }
  $$('wb-family').forEach((f) => f.paint && f.paint());
  if (sheet.isOpen()) sheet.render();
}
document.addEventListener('shopify:cart:lines-update', (e) => {
  const p = e && e.promise && e.promise.then ? e.promise : Promise.resolve();
  p.catch(() => {}).then(() => setTimeout(refreshCart, 60));
});
document.addEventListener('cart:update', () => setTimeout(refreshCart, 60));

/* ---------- zoom viewer (ảnh cận trong bảng chọn size) ---------- */
const viewer = (() => {
  let dlg, list, items = [], opener = null;
  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'wb-zv';
    dlg.setAttribute('aria-label', 'Design close-up');
    dlg.innerHTML = `<div class="wb-zv__top"><p class="wb-zv__cap"></p><span class="wb-zv__n"></span><button type="button" class="wb-zv__x" aria-label="Close zoom">${I.x}</button></div><div class="wb-zv__list"></div><p class="wb-zv__hint" aria-hidden="true"></p>`;
    document.body.appendChild(dlg);
    list = $('.wb-zv__list', dlg);
    $('.wb-zv__x', dlg).addEventListener('click', () => dlg.close());
    dlg.addEventListener('close', () => {
      items.forEach((o) => o.reset(false));
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
    let raf = 0;
    list.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; sync(); }); }, { passive: true });
  }
  const wide = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
  function hint() {
    const on = items.some((o) => o.zoomed());
    $('.wb-zv__hint', dlg).textContent = on
      ? (wide() ? 'Move the mouse to look around · click to zoom out' : 'Drag to look around · tap to zoom out')
      : (wide() ? 'Click the picture to zoom in' : 'Tap the picture to zoom in · pinch works too');
  }
  let cur = -1, vdata = [];
  function sync() {
    const kids = Array.from(list.children);
    if (!kids.length) return;
    const mid = list.scrollTop + list.clientHeight * 0.35;
    let best = 0, bd = Infinity;
    kids.forEach((k, j) => { const d = Math.abs(k.offsetTop + k.offsetHeight / 2 - mid); if (d < bd) { bd = d; best = j; } });
    if (list.scrollTop + list.clientHeight >= list.scrollHeight - 2) best = kids.length - 1;
    if (best !== cur) items.forEach((o, j) => { if (j !== best) o.reset(false); });
    cur = best;
    $('.wb-zv__cap', dlg).textContent = vdata[best].cap;
    $('.wb-zv__n', dlg).textContent = kids.length > 1 ? `${best + 1} / ${kids.length}` : '';
  }
  function zoomable(el, img, cap) {
    const z = { s: 1, tx: 0, ty: 0 }, ptrs = new Map();
    let g = null, lastTap = 0;
    const rel = (x, y) => { const r = el.getBoundingClientRect(); return { x: x - r.left - r.width / 2, y: y - r.top - r.height / 2 }; };
    const pts = () => Array.from(ptrs.values());
    const mid = (a, b) => rel((a.x + b.x) / 2, (a.y + b.y) / 2);
    const label = () => el.setAttribute('aria-label', (z.s > 1.001 ? 'Zoom out, ' : 'Zoom in, ') + cap);
    function clamp() {
      const mx = (z.s - 1) * el.clientWidth / 2, my = (z.s - 1) * el.clientHeight / 2;
      z.tx = Math.max(-mx, Math.min(mx, z.tx));
      z.ty = Math.max(-my, Math.min(my, z.ty));
    }
    function apply(anim) {
      const on = z.s > 1.001;
      img.style.transition = anim && !reduced() ? 'transform .25s ease' : 'none';
      img.style.transform = on ? `translate(${z.tx}px, ${z.ty}px) scale(${z.s})` : '';
      if (el.classList.contains('is-z') !== on) { el.classList.toggle('is-z', on); label(); hint(); }
    }
    function zoomAt(p, s) {
      const cx = (p.x - z.tx) / z.s, cy = (p.y - z.ty) / z.s;
      z.s = s; z.tx = p.x - s * cx; z.ty = p.y - s * cy; clamp();
    }
    const api = {
      zoomed: () => z.s > 1.001,
      reset(anim) { z.s = 1; z.tx = 0; z.ty = 0; apply(anim); },
      toggle(p) {
        if (api.zoomed()) { api.reset(true); return; }
        items.forEach((o) => { if (o !== api) o.reset(false); });
        const w = Math.max(1, el.clientWidth);
        zoomAt(p, Math.max(2, Math.min(3, (img.naturalWidth || 2 * w) / w)));
        apply(true);
      },
    };
    const one = (p, moved) => ({ mode: 'one', x0: p.x, y0: p.y, tx0: z.tx, ty0: z.ty, t0: Date.now(), moved });
    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (e.pointerType === 'touch') { try { el.setPointerCapture(e.pointerId); } catch (_) { /* ignore */ } }
      const p = pts();
      if (p.length === 1) g = one(p[0], false);
      else { const m = mid(p[0], p[1]); g = { mode: 'pinch', d0: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, s0: z.s, cx: (m.x - z.tx) / z.s, cy: (m.y - z.ty) / z.s }; }
    });
    el.addEventListener('pointermove', (e) => {
      if (e.pointerType === 'mouse' && api.zoomed()) {
        const q = rel(e.clientX, e.clientY);
        z.tx = -q.x * (z.s - 1); z.ty = -q.y * (z.s - 1); clamp(); apply(false);
      }
      if (!ptrs.has(e.pointerId)) return;
      ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
      const p = pts();
      if (g && g.mode === 'pinch' && p.length >= 2) {
        const m = mid(p[0], p[1]);
        z.s = Math.max(1, Math.min(4, g.s0 * Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) / g.d0));
        z.tx = m.x - z.s * g.cx; z.ty = m.y - z.s * g.cy; clamp(); apply(false);
      } else if (g && g.mode === 'one') {
        const dx = e.clientX - g.x0, dy = e.clientY - g.y0;
        if (Math.hypot(dx, dy) > 8) g.moved = true;
        if (api.zoomed() && e.pointerType !== 'mouse') { z.tx = g.tx0 + dx; z.ty = g.ty0 + dy; clamp(); apply(false); }
      }
    });
    const end = (e) => {
      if (!ptrs.has(e.pointerId)) return;
      ptrs.delete(e.pointerId);
      const left = pts();
      if (left.length === 1) { g = one(left[0], true); return; }
      if (left.length) return;
      const tap = e.type === 'pointerup' && g && g.mode === 'one' && !g.moved && Date.now() - g.t0 < 600;
      g = null;
      if (z.s < 1.08 && api.zoomed()) api.reset(true);
      if (!tap) return;
      const now = Date.now();
      if (now - lastTap < 320) { lastTap = 0; return; }
      lastTap = now;
      api.toggle(rel(e.clientX, e.clientY));
    };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('click', (e) => { if (e.detail === 0) api.toggle({ x: 0, y: 0 }); });
    label();
    return api;
  }
  function open(list0, from) {
    build();
    opener = from || document.activeElement;
    vdata = list0; items = []; cur = -1;
    list.innerHTML = '';
    list0.forEach((it) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'wb-zv__it';
      const img = document.createElement('img');
      img.alt = it.alt || '';
      img.draggable = false;
      img.src = it.src;
      b.appendChild(img);
      list.appendChild(b);
      items.push(zoomable(b, img, it.cap));
    });
    dlg.showModal();
    list.scrollTop = 0;
    hint();
    sync();
    $('.wb-zv__x', dlg).focus({ preventScroll: true });
  }
  return { open };
})();

/* ---------- bảng chọn size ---------- */
const sheet = (() => {
  let dlg, d = null, color = null, main = false, opener = null, busy = false;
  const pick = {};
  const key = (pid, c, s) => `${pid}|${c}|${s}`;
  const picksFor = (pid) => Object.keys(pick).filter((k) => pick[k] > 0 && k.indexOf(pid + '|') === 0).map((k) => {
    const [, c, s] = k.split('|');
    const v = d && String(d.id) === String(pid) ? d.v[`${c}|${s}`] : null;
    return { color: c, size: s, qty: pick[k], id: v ? v[0] : null, price: v ? v[1] : 0 };
  });
  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'wb-fs';
    dlg.setAttribute('aria-labelledby', 'wb-fs-title');
    dlg.innerHTML = `<span class="wb-fs__grab" aria-hidden="true"></span>
<div class="wb-fs__head"><button type="button" class="wb-fs__zoom" aria-label="See the design up close"><img alt="" width="64" height="64"><span class="wb-fs__zi">${I.mag}</span></button>
<div class="wb-fs__tt"><h2 id="wb-fs-title" tabindex="-1"></h2><p class="wb-fs__sub"></p><p class="wb-fs__hint">Tap the picture to see the design</p></div>
<button type="button" class="wb-fs__x" aria-label="Close">${I.x}</button></div>
<div class="wb-fs__body"><div class="wb-fs__blk" role="group" aria-labelledby="wb-fs-cl"><p class="wb-fs__sec"><span id="wb-fs-cl">Color<span class="wb-fs__v"></span></span></p><div class="wb-fs__colors"></div></div>
<div class="wb-fs__blk" role="group" aria-labelledby="wb-fs-sl"><div class="wb-fs__sec"><span id="wb-fs-sl">Sizes</span><button type="button" class="wb-fs__fms">Find my size</button></div><ul class="wb-fs__rows"></ul></div></div>
<div class="wb-fs__foot"><div class="wb-fs__goal"><p class="wb-fs__gt" aria-live="polite"><span class="wb-fs__gtext"></span><span class="wb-fs__save"></span></p><div class="wb-prog" aria-hidden="true"><i></i><i></i></div></div>
<p class="wb-fs__picks" hidden></p><p class="wb-fs__err" role="alert" hidden></p>
<button type="button" class="wb-fs__cta" disabled><span class="wb-fs__cl"></span><span class="wb-fs__cp"></span></button>
<p class="wb-fs__fine"></p></div>`;
    document.body.appendChild(dlg);
    $('.wb-fs__x', dlg).addEventListener('click', () => close());
    $('.wb-fs__cta', dlg).addEventListener('click', add);
    $('.wb-fs__zoom', dlg).addEventListener('click', (e) => {
      const im = d.img[color] || {};
      const list = [];
      if (im.z) list.push({ src: im.z, cap: `${color} · Print close-up`, alt: `${d.title}, print close-up, ${color}` });
      if (im.f) list.push({ src: im.f, cap: `${color} · Flat lay`, alt: `${d.title} in ${color}, flat lay` });
      if (list.length) viewer.open(list, e.currentTarget);
    });
    $('.wb-fs__fms', dlg).addEventListener('click', () => {
      const g = $('.wb-sg');
      const dc = g && g.closest('dialog-component');
      if (dc && typeof dc.showDialog === 'function') dc.showDialog();
      else { const o = dc && dc.querySelector('.popup-link__button'); if (o) o.click(); }
    });
    dlg.addEventListener('click', (e) => {
      if (e.target !== dlg) return;
      const r = dlg.getBoundingClientRect();
      if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) close();
    });
    dlg.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus({ preventScroll: true }); });
  }
  function rowsFor() {
    const ul = $('.wb-fs__rows', dlg);
    ul.innerHTML = '';
    d.sizes.forEach((s) => {
      const v = d.v[`${color}|${s}`];
      const li = document.createElement('li');
      li.className = 'wb-fs__row';
      li.dataset.size = s;
      li.innerHTML = `<span class="wb-fs__sz">${esc(s)}</span><span class="wb-fs__pr"></span><button type="button" class="wb-fs__plus">${I.plus}</button><span class="wb-fs__qp" role="group" hidden><button type="button" data-m>${I.minus}</button><output>0</output><button type="button" data-p>${I.plus}</button></span>`;
      $('.wb-fs__pr', li).textContent = v ? (v[3] ? money(v[1]) : 'Sold out') : 'Unavailable';
      const plus = $('.wb-fs__plus', li);
      plus.disabled = !(v && v[3]);
      plus.addEventListener('click', () => { bump(s, 1); const p = $('[data-p]', li); if (p) p.focus(); });
      $('[data-m]', li).addEventListener('click', () => { bump(s, -1); if (!(pick[key(d.id, color, s)] > 0)) plus.focus(); });
      $('[data-p]', li).addEventListener('click', () => bump(s, 1));
      ul.appendChild(li);
    });
  }
  function bump(s, by) {
    const k = key(d.id, color, s);
    pick[k] = Math.max(0, Math.min(MAXQ, (pick[k] || 0) + by));
    $('.wb-fs__err', dlg).hidden = true;
    render();
  }
  function quote(n, sub) {
    const c = cartN();
    const save = (c + n >= 2 ? BUY2 : 0) - (c >= 2 ? BUY2 : 0);
    let state = 'empty';
    if (n > 0) state = save > 0 ? 'saved' : (c + n === 1 ? 'one' : 'already');
    return { n, sub, save, total: sub - save, state, have: Math.min(2, c + n), c };
  }
  function render() {
    if (!dlg || !d) return;
    $('#wb-fs-title', dlg).textContent = main ? 'Pick sizes for everyone' : 'Add to your set';
    $('.wb-fs__sub', dlg).textContent = d.title;
    $('.wb-fs__hint', dlg).textContent = matchMedia('(hover: hover) and (pointer: fine)').matches ? 'Click the picture to see the design' : 'Tap the picture to see the design';
    const im = d.img[color] || {};
    $('.wb-fs__zoom img', dlg).src = im.c || im.t || '';
    $('.wb-fs__v', dlg).textContent = color;
    const box = $('.wb-fs__colors', dlg);
    if (box.childElementCount !== d.colors.length || box.dataset.pid !== String(d.id)) {
      box.innerHTML = '';
      box.dataset.pid = d.id;
      d.colors.forEach((c) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'wb-fs__c';
        b.dataset.color = c;
        b.innerHTML = '<img alt="" width="52" height="52"><span class="wb-fs__cnt" hidden></span>';
        $('img', b).src = (d.img[c] || {}).t || '';
        b.addEventListener('click', () => { if (color !== c) { color = c; rowsFor(); render(); } });
        box.appendChild(b);
      });
    }
    $$('.wb-fs__c', box).forEach((b) => {
      const c = b.dataset.color;
      const n = d.sizes.reduce((a, s) => a + (pick[key(d.id, c, s)] || 0), 0);
      b.setAttribute('aria-pressed', String(c === color));
      b.setAttribute('aria-label', c + (n ? `, ${n} picked` : ''));
      const cnt = $('.wb-fs__cnt', b);
      cnt.hidden = !n;
      cnt.textContent = n;
    });
    $$('.wb-fs__row', dlg).forEach((li) => {
      const s = li.dataset.size, q = pick[key(d.id, color, s)] || 0;
      const plus = $('.wb-fs__plus', li), qp = $('.wb-fs__qp', li);
      plus.hidden = q > 0;
      plus.setAttribute('aria-label', `Add ${color} ${s}`);
      qp.hidden = q === 0;
      qp.setAttribute('aria-label', `${color} ${s}, ${q}`);
      $('output', qp).textContent = q;
      $('[data-m]', qp).setAttribute('aria-label', `One less ${color} ${s}`);
      $('[data-p]', qp).setAttribute('aria-label', `One more ${color} ${s}`);
      $('[data-p]', qp).disabled = q >= MAXQ;
    });
    const ps = picksFor(d.id);
    const q = quote(ps.reduce((a, p) => a + p.qty, 0), ps.reduce((a, p) => a + p.qty * p.price, 0));
    const gt = $('.wb-fs__gtext', dlg), sv = $('.wb-fs__save', dlg);
    sv.textContent = '';
    if (q.state === 'saved') { gt.innerHTML = `<span class="wb-fs__ok">${I.check}Buy 2, save $10 unlocked</span>`; sv.textContent = '−' + money(q.save); }
    else if (q.state === 'already') gt.innerHTML = `<span class="wb-fs__ok">${I.check}Buy 2, save $10 is in your cart</span>`;
    else if (q.state === 'one') gt.textContent = 'Add 1 more tee to save $10';
    else gt.textContent = q.c === 1 ? '1 tee in your cart. Add 1 more to save $10' : (q.c >= 2 ? 'Buy 2, save $10 is in your cart' : 'Pick 2 or more tees to save $10');
    const prog = $('.wb-fs__goal .wb-prog', dlg);
    $$('i', prog).forEach((i, j) => i.classList.toggle('on', j < q.have));
    prog.classList.toggle('wb-prog--ok', q.have >= 2);
    const pk = $('.wb-fs__picks', dlg);
    pk.hidden = !ps.length;
    pk.textContent = 'Your picks: ' + ps
      .sort((a, b) => d.colors.indexOf(a.color) - d.colors.indexOf(b.color) || d.sizes.indexOf(a.size) - d.sizes.indexOf(b.size))
      .map((p) => `${p.color} ${p.size}${p.qty > 1 ? ' ×' + p.qty : ''}`).join(', ');
    const cta = $('.wb-fs__cta', dlg);
    cta.disabled = !q.n;
    $('.wb-fs__cl', dlg).textContent = q.n ? `Add ${q.n} ${q.n === 1 ? 'tee' : 'tees'}` : 'Pick a size to continue';
    $('.wb-fs__cp', dlg).textContent = q.n ? money(q.total) : '';
  }
  function open(data0, c, from, carry, isMain) {
    build();
    d = data0;
    color = d.colors.indexOf(c) >= 0 ? c : d.colors[0];
    main = !!isMain;
    opener = from || document.activeElement;
    if (carry && !picksFor(d.id).length && d.v[`${color}|${carry.size}`]) pick[key(d.id, color, carry.size)] = carry.qty;
    const cut = (document.querySelector('wb-family[data-cut]') || {}).dataset;
    $('.wb-fs__fine', dlg).textContent = 'One shipping fee for the whole order' + (cut && cut.cut ? ' · ' + cut.cut : '');
    $('.wb-fs__err', dlg).hidden = true;
    $('.wb-fs__colors', dlg).innerHTML = '';
    rowsFor();
    render();
    $('.wb-fs__body', dlg).scrollTop = 0;
    if (!dlg.open) dlg.showModal();
    $('#wb-fs-title', dlg).focus({ preventScroll: true });
  }
  function close() { if (dlg && dlg.open) dlg.close(); }
  async function add() {
    const ps = picksFor(d.id).filter((p) => p.id);
    const cta = $('.wb-fs__cta', dlg), err = $('.wb-fs__err', dlg);
    if (!ps.length || busy) return;
    busy = true;
    cta.setAttribute('aria-busy', 'true');
    err.hidden = true;
    const A = window.Shopify && window.Shopify.actions;
    try {
      if (A && A.updateCart) {
        const res = await A.updateCart({ lines: ps.map((p) => ({ merchandiseId: String(p.id), quantity: p.qty })) }, { event: { context: 'product' } });
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      } else {
        const r = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ps.map((p) => ({ id: p.id, quantity: p.qty })) }),
        });
        if (!r.ok) throw new Error('cart/add ' + r.status);
        window.location.href = cartUrl();
        return;
      }
      ps.forEach((p) => { delete pick[key(d.id, p.color, p.size)]; });
      cart.n = cartN() + ps.reduce((a, p) => a + p.qty, 0);
      $$('wb-family').forEach((f) => f.paint && f.paint());
      opener = null;
      close();
      setTimeout(() => { if (A.openCart) A.openCart(); else window.location.href = cartUrl(); }, reduced() ? 0 : 280);
    } catch (e) {
      console.warn('[wb-family] add to cart failed', e);
      err.textContent = "Couldn't add to cart. Please try again.";
      err.hidden = false;
    } finally {
      busy = false;
      cta.removeAttribute('aria-busy');
    }
  }
  return { open, render, close, isOpen: () => !!(dlg && dlg.open) };
})();

/* ---------- <wb-family> ---------- */
class WbFamily extends HTMLElement {
  connectedCallback() {
    if (this._on) return;
    this._on = true;
    cartN();
    const btn = $('[data-open]', this);
    if (!btn) return;
    btn.addEventListener('click', () => this.open(btn));
    if (window.location.hash === '#wb-sizes') {
      /* đến từ "Add another size" trong giỏ: mở bảng với màu đang chọn, không chọn sẵn size (size đó đã có trong giỏ) */
      history.replaceState(null, '', window.location.pathname + window.location.search);
      setTimeout(() => { closeDrawer(); this.open(btn, this.checked('Color') || null); }, 500);
    }
  }
  checked(name) {
    const vp = $('variant-picker[data-template-product-match]') || $('.product-details variant-picker') || $('variant-picker');
    const i = vp && $(`input[type=radio][data-option-name="${name}"]:checked`, vp);
    return i ? i.value : '';
  }
  paint() {
    const n = cartN();
    const h = $('[data-h]', this), dd = $('[data-d]', this), p = $('[data-prog]', this);
    if (!h || !dd || !p) return;
    if (n === 0) { h.textContent = 'Buy any 2 tees, save $10'; dd.textContent = 'Applied automatically at checkout. Mix any designs, colors or sizes.'; }
    else if (n === 1) { h.textContent = '1 tee in your cart. Add 1 more to save $10'; dd.textContent = 'Mix any designs, colors or sizes.'; }
    else { h.textContent = 'Buy 2, save $10 is applied to your cart'; dd.textContent = 'Shipping is one fee per order, not per tee.'; }
    p.hidden = n === 0;
    p.classList.toggle('wb-prog--ok', n >= 2);
    $$('i', p).forEach((i, j) => i.classList.toggle('on', j < Math.min(2, n)));
  }
  open(from, color) {
    const d = data(this.dataset.pid);
    if (!d) return;
    const vp = $('variant-picker[data-template-product-match]') || $('.product-details variant-picker') || $('variant-picker');
    const cIn = vp && $('input[type=radio][data-option-name="Color"]:checked', vp);
    const sIn = vp && $('input[type=radio][data-option-name="Size"]:checked', vp);
    let carry = null;
    if (!color && sIn && d.sizes.indexOf(sIn.value) >= 0) {
      const qi = $('.product-details input[name="quantity"]') || $('product-form-component input[name="quantity"]');
      carry = { size: sIn.value, qty: Math.max(1, Math.min(MAXQ, Number(qi && qi.value) || 1)) };
    }
    sheet.open(d, color || (cIn && cIn.value) || d.colors[0], from, carry, true);
  }
}
if (!customElements.get('wb-family')) customElements.define('wb-family', WbFamily);

/* nút + trên thẻ Complete the set; link "Add another size" trong ngăn kéo giỏ */
document.addEventListener('click', (e) => {
  const t = e.target instanceof Element ? e.target : null;
  const q = t && t.closest('[data-wb-quick]');
  if (q) {
    const d = data(q.dataset.wbQuick);
    if (d) { e.preventDefault(); sheet.open(d, d.colors[0], q, null, false); }
    return;
  }
  const m = t && t.closest('a[data-wb-more]');
  if (m) {
    const f = document.querySelector(`wb-family[data-pid="${m.dataset.pid}"]`);
    const btn = f && $('[data-open]', f);
    if (!btn) return;
    e.preventDefault();
    closeDrawer();
    setTimeout(() => f.open(btn, m.dataset.color || null), 320);
  }
});

/* ---------- <wb-zoom-hint>: kính lúp + "Tap to zoom" ---------- */
class WbZoomHint extends HTMLElement {
  connectedCallback() {
    const g = this.closest('media-gallery');
    if (!g) return;
    const host = $('slideshow-container', g);
    if (host && this.parentElement !== host) { host.appendChild(this); return; }
    if (this._on) return;
    this._on = true;
    if (getComputedStyle(this.parentElement).position === 'static') this.parentElement.style.position = 'relative';
    this.hidden = false;
    $('.wb-zh__btn', this).addEventListener('click', (e) => {
      const slides = $$('slideshow-slide', g);
      let i = slides.findIndex((s) => s.getAttribute('aria-hidden') === 'false');
      if (i < 0) i = 0;
      this.tip(false);
      /* bấm vào chính ảnh đang xem, như khách tự bấm ảnh: Horizon mở khung zoom có hiệu ứng và chọn đúng ảnh nhỏ */
      const s = slides[i];
      const t = s && (s.matches('[on\\:click*="/open/"]') ? s : $('[on\\:click*="/open/"]', s));
      if (t) t.click();
      else if (typeof g.zoom === 'function') g.zoom(i, e);
    });
    if (!window.__wbZoomTip) {
      window.__wbZoomTip = true;
      /* hiện 5 giây, tính từ lúc ảnh đầu tải xong (tối đa chờ 2,5 giây) */
      const go = () => {
        if (this._shown || this._done) return;
        this._shown = true;
        this.tip(true);
        this._t = setTimeout(() => this.tip(false), 5000);
      };
      const img = $('slideshow-slide img', g);
      if (!img || img.complete) go();
      else { img.addEventListener('load', go, { once: true }); setTimeout(go, 2500); }
      g.addEventListener('slideshow:select', (e) => {
        if (e.detail && e.detail.userInitiated === false) return;
        this._done = true;
        this.tip(false);
      });
    }
  }
  tip(on) {
    this.classList.toggle('is-tip', on);
    if (!on) clearTimeout(this._t);
  }
}
if (!customElements.get('wb-zoom-hint')) customElements.define('wb-zoom-hint', WbZoomHint);
